module.exports = __webpack_public_path__ + "img/integration.32f5a374.svg";